<template>
  <div style="display: flex;flex-direction: column;width:100%;">
    <div v-if="title"
         style="width: 100%;margin: 10px 0;display: flex;flex-direction: row;align-items: center;justify-content: center;">
      <div :style="{
        borderRadius: '5px',width:'60px',height:'1px',backgroundColor:hcf.getMainColor()+'5a'
      }"/>
      <div :style="{
        borderRadius:'10px',width:'5px',height:'5px',border: `${hcf.getMainColor()+'5a'} 2px solid`,
      }"/>
      <div :style="hcf.getTextStyle({
        color:'main',marginRight: 5,marginLeft: 5,fontWeight:'bold',addSize:1
      })">{{ title }}
      </div>
      <div :style="{
        borderRadius:'10px',width:'5px',height:'5px',border: `${hcf.getMainColor()+'5a'} 2px solid`,
      }"/>
      <div :style="{
        borderRadius: '5px',width:'60px',height:'1px',backgroundColor:hcf.getMainColor()+'5a'
      }"/>
    </div>
    <div :style="{
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0 13px',
    alignItems: 'center',
    columnGap:'13px',
  }">
      <div v-for="(eachItem,index) in eachTemplate['ItemList']" :key="eachItem['Id']" :style="{
          marginBottom:eachRowCount>1?(HNewGameUIConfig.newGameUIType === 4&&title?'0':'13px'):'7px',
        }">

        <div @click="clickCheckMore(eachItem)"
             v-if="((eachTemplate['HaveMore']??false) && eachTemplate['ItemList'].length-1 === index)" :style="{
          width:eachImgWidth+'px',
          border:hcf.getMainColor()+' 1px dashed',
          height:eachImgWidth+10+'px',
          borderRadius:'10px',
          display:'flex',
          alignItems:'center',
          justifyContent:'center',
          color:hcf.getMainColor(),
          backgroundColor:hcf.getMainColor()+'22',
          fontSize:'14px',
        }">
          查看更多
        </div>

        <EachGameItem v-if="!((eachTemplate['HaveMore']??false) && eachTemplate['ItemList'].length-1 === index)"
                      :isHaveTitle="title"
                      :itemInfo="eachItem"
                      :eachRowCount="eachRowCount"
                      :eachImgWidth="eachImgWidth"
                      :favoriteCallback="favoriteCallback"
                      :isFromHome="true"
        />
      </div>
    </div>
  </div>
</template>


<script setup>
  import {hcf, log} from "@/components/utils/HComFunctions.js";
  import EachGameItem from "@/components/pages/EachGameItem.vue";
  import {useClickModal} from "@/hooks/useClickModal.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {useResponsive, getContentWidth} from "@/hooks/useResponsive.js";

  const props = defineProps(["eachTemplate", "favoriteCallback"]);
  const {isDesktop} = useResponsive();
  //移动端一行几个元素(原逻辑)
  let mobileRowCount = 3;
  let title = ref(props.eachTemplate["Title"]);
  switch (props.eachTemplate["TemplateType"]) {
    case 1:
      mobileRowCount = 1;
      break;
    case 2:
      mobileRowCount = 1;
      break;
    case 3:
      mobileRowCount = 2;
      break;
    case 4:
    case 5:
    case 6:
    case 7:
      mobileRowCount = 3;
      break;
    case 999:
      mobileRowCount = 4;
      break;
    default:
      mobileRowCount = 3;
      break;
  }
  // 桌面宽屏: 每行列数放大, 把移动端窄列重排为宽屏多列(1列保持单行大图不动)
  const desktopColMap = {1: 1, 2: 4, 3: 6, 4: 8};
  const eachRowCount = computed(() =>
      isDesktop.value ? (desktopColMap[mobileRowCount] || mobileRowCount) : mobileRowCount);
  let eachSpace = 13;
  // 图标宽: 移动端用 clientWidth 兜底(被 hsxs_h5 以 <iframe srcdoc> 内嵌时首帧视口可能偏大,
  // 故挂载后 + resize 重算自动修正); 桌面端用「内容区居中定宽」的实宽(getContentWidth)为基准,
  // 而非整屏窗口宽, 否则限宽后图标仍按整屏算会过大/溢出。
  function calcEachImgWidth() {
    const vw = getContentWidth();
    // 移动端左侧有 76px 分类栏, 瀑布只占 (宽-76); 桌面分类栏改到顶部、瀑布满宽, 不能再减 76,
    // 否则每张图偏窄、整行填不满 → 右侧多出一段空白、看着不居中。
    const sideInset = isDesktop.value ? 0 : 76;
    return (vw - sideInset - eachSpace * (eachRowCount.value + 1)) / eachRowCount.value;
  }
  const eachImgWidth = ref(calcEachImgWidth());
  function onViewportResize() {
    const w = calcEachImgWidth();
    if (w > 0 && w !== eachImgWidth.value) eachImgWidth.value = w;
  }
  // 断点跨越(如浏览器缩放跨 1024)时列数变化, 同步重算图标宽
  watch(eachRowCount, onViewportResize);
  onMounted(() => {
    onViewportResize();
    requestAnimationFrame(onViewportResize);
    setTimeout(onViewportResize, 300);
    window.addEventListener('resize', onViewportResize);
  });
  onUnmounted(() => {
    window.removeEventListener('resize', onViewportResize);
  });
  const clickModal = useClickModal();

  function clickCheckMore(itemInfo) {
    clickModal.onClick(itemInfo);
  }
</script>


<style scoped>
  ::v-deep(.van-grid-item__content) {
    line-height: normal !important; /* 设置为正常行高 */
  }

  ::v-deep(.van-grid-item__content--center) {
    line-height: normal !important; /* 设置为正常行高 */
  }

  ::v-deep(.van-grid-item__content) {
    padding: 0 !important;
  }
</style>
